var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from '@apollo/client';
import { Button, DialogActions } from '@mui/material';
import { ActivityValidationLevels } from 'common/enums/activity/activity-validation-levels.enum';
import { SnackbarSeverity } from 'common/enums/components/snackbar-severity.enum';
import { UPDATE_ACTIVITY_VALIDATION } from 'common/graphql/mutations/activity/updateActivityValidation/updateActivityValidation';
import { ACTIVITY_VALIDATION } from 'common/graphql/queries/activity/activityValidation';
import useDynamicMutation from 'common/hooks/useDynamicMutation';
import ActivityValidationSportEventAutocomplete from 'components/Autocomplete/ActivityValidationSportEventAutocomplete';
import ActivityValidationLevelSelect from 'components/Select/ActivityValidationLevelSelect';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { openSnackbar } from 'store/actions';
var ActivityValidationChangeLevelDialog = function (_a) {
    var _b;
    var activityValidation = _a.activityValidation, handleClose = _a.handleClose;
    var t = useTranslation().t;
    var _c = useState(activityValidation.validationLevel), validationLevel = _c[0], setValidationLevel = _c[1];
    var _d = useState((_b = activityValidation.sportEvent) === null || _b === void 0 ? void 0 : _b.id), targetEntityId = _d[0], setTargetEntityId = _d[1];
    var handleChange = function (name, value) {
        setValidationLevel(value);
    };
    var dispatch = useDispatch();
    var onSuccess = function () {
        dispatch(openSnackbar({
            message: t("\u0414\u0430\u043D\u043D\u044B\u0435 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u044B"),
            severity: SnackbarSeverity.SUCCESS
        }));
        handleClose();
    };
    var onError = function (_a) {
        var code = _a.code;
        dispatch(openSnackbar({
            message: code,
            severity: SnackbarSeverity.ERROR
        }));
    };
    var updateActivityValidation = function (data) {
        return useMutation(UPDATE_ACTIVITY_VALIDATION, {
            variables: {
                updateActivityValidationData: __assign({}, data)
            },
            awaitRefetchQueries: true,
            refetchQueries: [
                {
                    query: ACTIVITY_VALIDATION,
                    variables: {
                        id: activityValidation.id
                    }
                },
            ]
        });
    };
    var handleExecuteMutation = useDynamicMutation(updateActivityValidation, onSuccess, onError).handleExecuteMutation;
    return (_jsxs("div", __assign({ className: "flex flex-col h-full" }, { children: [_jsxs("div", __assign({ className: "flex flex-col space-y-5 p-0 pb-20" }, { children: [_jsx("div", __assign({ className: "tw-dialog-header" }, { children: t('Изменить уровень валидации') }), void 0), _jsx(ActivityValidationLevelSelect, { value: validationLevel, handleChange: handleChange, disableClearable: false }, void 0), validationLevel === ActivityValidationLevels.SportEvent && (_jsx(ActivityValidationSportEventAutocomplete, { sportEventId: targetEntityId, setSportEventId: setTargetEntityId, validationLevel: validationLevel }, void 0))] }), void 0), _jsxs(DialogActions, __assign({ className: "flex justify-between p-0" }, { children: [_jsx(Button, __assign({ variant: "text", onClick: handleClose }, { children: t('Отмена') }), void 0), _jsx(Button, __assign({ type: "submit", onClick: function () {
                            handleExecuteMutation({ id: activityValidation.id, validationLevel: validationLevel, targetEntityId: targetEntityId });
                        } }, { children: t('Сохранить') }), void 0)] }), void 0)] }), void 0));
};
export default ActivityValidationChangeLevelDialog;
